var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:{ inverted: _vm.inverted },style:({
      borderWidth: _vm.thickness + 'px',
      borderColor: 'rgba(' + _vm.color + ', .25)',
      borderLeftColor: _vm.color,
      height: _vm.size + 'px',
      width: _vm.size + 'px'
    })})}
var staticRenderFns = []

export { render, staticRenderFns }